// document.addEventListener('DOMContentLoaded', function () {
//   const mediaQuery = window.matchMedia('(max-width: 768px)');
//   const plainLinks = document.querySelectorAll('.plain-link');

//   function handleResponsiveClick() {
//     if (mediaQuery.matches) {
//       // 768px or below
//       plainLinks.forEach(link => {
//         if (!link.dataset.mobileClicked) {
//           link.click();
//           link.dataset.mobileClicked = 'true';
//           link.style.display = 'none';
//         }
//       });
//     } else {
//       // Above 768px
//       plainLinks.forEach(link => {
//         link.dataset.mobileClicked = '';
//         link.style.display = '';
//       });

//       // Click close icon
//       const closeIcon = document.querySelector('.search-form__icon-close');
//       if (closeIcon) {
//         closeIcon.click();
//       }
//     }
//   }

//   handleResponsiveClick();

//   mediaQuery.addEventListener('change', handleResponsiveClick);
// });



document.addEventListener('DOMContentLoaded', function () {
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  const plainLinks = document.querySelectorAll('.plain-link');

  function hideFocusTint() {
    const focusTint = document.querySelector('.search-bar-open .focus-tint');

    if (focusTint) {
      focusTint.style.opacity = '0';
      focusTint.style.visibility = 'hidden';
    }
  }

  function showFocusTint() {
    const focusTint = document.querySelector('.search-bar-open .focus-tint');

    if (focusTint) {
      focusTint.style.opacity = '';
      focusTint.style.visibility = '';
    }
  }

  function handleResponsiveClick() {
    if (mediaQuery.matches) {
      // 768px or below
      plainLinks.forEach(link => {
        if (!link.dataset.mobileClicked) {
          link.click();
          link.dataset.mobileClicked = 'true';
          link.style.display = 'none';
        }
      });

      // Hide focus tint after search bar opens
      setTimeout(() => {
        hideFocusTint();
      }, 100);

    } else {
      // Above 768px
      plainLinks.forEach(link => {
        link.dataset.mobileClicked = '';
        link.style.display = '';
      });

      // Click close icon
      const closeIcon = document.querySelector('.search-form__icon-close');

      if (closeIcon) {
        closeIcon.click();
      }
    }
  }

  handleResponsiveClick();

  mediaQuery.addEventListener('change', handleResponsiveClick);

  // Only show the focus tint when the user
  // manually clicks the search button
  document.addEventListener('click', function (event) {
    const manuallyOpenedSearch = event.target.closest('#open-search-mobile-closed');

    if (manuallyOpenedSearch) {
      showFocusTint();
    } else {
      // Keep focus tint hidden for all other clicks
      hideFocusTint();
    }
  });
});